
import { Component, Vue } from "vue-property-decorator";
import V15Config from "./components/v15-config.vue";
import UploadImgAfter from "@/components/UploadImg-ai.vue";
import Editor5 from "@/components/editor/classic-editor5.vue";
import Pop from "@/views/ai-builder/components/blue-pop.vue";
import UploadImgBefore from "@/components/UploadImg-ai.vue";
import myCollapse from "@/views/ai-builder/step-view/components/myCollapse.vue";
import { RedirectConfig } from "@/lib/model/company/company";
import vuexStore from "@/store/vuex-store";

@Component({
  components: {
    V15Config,
    myCollapse,
    UploadImgBefore,
    Pop,
    Editor5,
    UploadImgAfter
  }
})
export default class CompanyConfig extends Vue {
  redirectConfig = new RedirectConfig();
  hasChange = false;
  submitting = false;
  vuexStores = vuexStore;
  defaultLogo =
    "https://qx-business-licence.oss-cn-beijing.aliyuncs.com/aiInterview/static/mp/jump/logo.png";

  // 添加版本控制变量
  isV15 = false;

  get logoUrl() {
    return (
      this.vuexStores.company.logoUrl ||
      this.vuexStores.user.viConfig.specialLogoOss
    );
  }

  created() {
    RedirectConfig.get().then(res => {
      if (res.code !== 0) return;

      this.redirectConfig.assign({
        content: res.data.content || "请点击下方按钮，在微信小程序面试",
        imgUrl: res.data.imgUrl,
        isClose: res.data.isClose,
        title: res.data.title || "欢迎参加面试",
        isOutClose: res.data.isOutClose,
        outUrl: res.data.outUrl || "",
        outTitle: res.data.outTitle || "跳转小程序",
        outAppId: res.data.outAppId || ""
      });
    });
  }

  //上传图片
  uploadedBeforeImg(d: any) {
    this.redirectConfig.imgUrl = d;
    this.hasChange = true;
  }

  showReset = {
    content: false,
    title: false,
    outTitle: false
  };

  changeText(key: string) {
    this.showReset[key] =
      this.redirectConfig[key] !== new RedirectConfig()[key];
  }

  resetDefault(key: string) {
    this.redirectConfig[key] = new RedirectConfig()[key];
    this.hasChange = true;
    this.showReset[key] = false;
  }

  cancel() {
    RedirectConfig.get().then(res => {
      if (res.code !== 0) return;

      this.redirectConfig.assign(res.data);
      this.hasChange = false;
    });
  }

  submit() {
    if (this.submitting) return;

    if (
      (this.redirectConfig.isClose === 0 &&
        !this.redirectConfig.title.trim()) ||
      !this.redirectConfig.content.trim()
    ) {
      return this.$message.error("标题和正文不能为空");
    }

    if (
      (this.redirectConfig.isOutClose === 0 &&
        !this.redirectConfig.outUrl.trim()) ||
      !this.redirectConfig.outTitle.trim() ||
      !this.redirectConfig.outAppId.trim()
    ) {
      return this.$message.error("按钮文案、小程序appId和小程序path不能为空");
    }

    this.submitting = true;

    RedirectConfig.save(this.redirectConfig).then(res => {
      if (res.code !== 0) return;

      this.$message.success("保存成功");
      this.hasChange = false;
      this.submitting = false;
    });
  }
}
